
const SaltoIndividual = ({axios, env})=>({
    Individual : async ( body ) => {
        try {
            const { data } = await axios.post( `${env.api_uri}/test/individual-jump-stats-mac`, body )
            return data
        } catch (error) {
            console.log(error)
        }
    },
    Stats : async ( body ) => {
        try {
            const { data } = await axios.post( `${env.api_uri}/test/individual-jump-stats`, body )
            return data
        } catch (error) {
            console.log(error)
        }
    },
    Dates : async (_id)=>{
        try {
            const { data } = await axios.get(`${env.api_uri}/test/individual-jump-dates/${_id}`)
            return data
        }catch(error){
            console.log(error)
        }
    }
    

})


export default SaltoIndividual